import type { components } from '~/fecom-api/schema';
import { cn } from '~/lib/utils';

type RoundelsProps = {
  roundels?: components['schemas']['Roundel'][];
  fecomMediaBaseUrl: string;
  isDiscountPrice?: boolean;
  isContractPrice?: boolean;
};

const priorityOrder = [
  'Your Price',
  'Clearance',
  'Reduced',
  'Buy More Save More',
  'Best Seller',
  'New',
  'Exclusive',
  'Eco Friendly',
];

type ProductRoundelProps = {
  name: string;
};

export function Roundels(props: RoundelsProps) {
  const allBadges = new Map<string, ProductRoundelProps>();

  if (props.isDiscountPrice) {
    allBadges.set('Your Price', {
      name: 'Your Price',
    });
  }

  if (props.roundels) {
    props.roundels.forEach((roundel) => {
      const name = roundel.name;

      switch (name) {
        case 'Clearance':
          allBadges.set('Clearance', {
            name: roundel.text ?? 'Clearance',
          });
          break;
        case 'Reduced':
          allBadges.set('Reduced', {
            name: roundel.text ?? 'Reduced',
          });
          break;
        case 'Buy More Save More':
          allBadges.set('Buy More Save More', {
            name: roundel.text ?? 'Buy More Save More',
          });
          break;
        case 'Best Seller':
          allBadges.set('Best Seller', {
            name: roundel.text ?? 'Best Seller',
          });
          break;
        case 'New':
          allBadges.set('New', {
            name: roundel.text ?? 'New',
          });
          break;
        case 'Exclusive':
          allBadges.set('Exclusive', {
            name: roundel.text ?? 'Exclusive',
          });
          break;
        case 'Eco':
          allBadges.set('Eco Friendly', {
            name: 'Sustainable',
          });
          break;
        default:
          break;
      }
    });
  }

  if (allBadges.size === 0) {
    return null;
  }

  const sortedBadges: ProductRoundelProps[] = [];

  for (const key of priorityOrder) {
    if (allBadges.has(key)) {
      sortedBadges.push(allBadges.get(key)!);
    }
  }

  if (sortedBadges.length === 0) return null;

  const roundelName = sortedBadges[0]?.name;

  const roundelGroup = getRoundelGroup(roundelName ?? '');

  return (
    <p className="pointer-events-none absolute bottom-0 left-0 right-0 flex gap-1 overflow-hidden rounded-b-lg">
      <span
        key={roundelName}
        className={cn('roundel roundel--' + roundelGroup, 'text-xs sm:text-sm')}
      >
        {roundelName}
      </span>
    </p>
  );
}

function getRoundelGroup(roundelName: string) {
  switch (roundelName.toLowerCase()) {
    case 'new':
    case 'best seller':
    case 'exclusive':
      return 'group-highlights';

    case 'sustainable':
    case 'eco friendly':
      return 'group-other';

    case 'buy more save more':
    case 'clearance':
    case 'your price':
    case 'reduced':
      return 'group-savings';
    default:
      return '';
  }
}
